import React,{useState,useImperativeHandle,forwardRef,useEffect} from 'react'
import { Avatar,List,Modal,message,Pagination,Empty,Input } from 'antd';
import { merchantList,switchMerchant } from '@/services/login';
import { ResDataType } from "@/services/ajax";
import usePagination from '@/hooks/usePagAndCommon';
import { useNavigate } from 'react-router-dom';
import { setMerchant } from '@/store/userReducer';
import { useDispatch, useSelector } from'react-redux';
import usePagAndCommon from '@/hooks/usePagAndCommon';
import { debounce } from "@/utils"
import { RootType } from '@/store';
interface DataType {
    merchantId:number,
    merchantName:string
}
 const MerchantList = (props:any,ref:any) => {
    const router = useNavigate();
    const dispatch = useDispatch();
    const { merchantId } = useSelector((state:RootType) => state.user);
    const { isModalOpen,setIsModalOpen,flag,setFlag } = usePagAndCommon();
    const [name,setName] = useState('');
    const [data,setData] = useState<DataType[]>([]);
    const { page,setPage,pageSize,setPageSize,total,setTotal } = usePagination();
    const showModal = () => {
      setName('');
      fetchData('',1);
      setIsModalOpen(true);
    };
    
    const handleCancel = () => {
      setIsModalOpen(false);
    };
    const fetchData = async (value:string,pageIndex:number=1) => {
        setFlag(true)
        setPage(pageIndex)
        const res = await merchantList(pageIndex,pageSize,value) as ResDataType;
        if (res.code!= 0) {
          message.error(res.message);
          return;
        } 
        setData(res.data.list);
        setTotal(res.data.total);
        setFlag(false)
    }
    const debouncedSearch = debounce((value:string) => {
        fetchData(value,1)
    });
        
    const handleSearch = (value:string) => {
        debouncedSearch(value);
    };
    const selectMerchant = (merchantId:number,merchantName:string) => {
        switchMerchant(merchantId).then((res:ResDataType)=>{
            if (res.code == 0) {
                localStorage.setItem('merchantId',merchantId.toString());
                dispatch(setMerchant({merchantId,merchantName}));
                message.success('登录成功');
                setIsModalOpen(false);
                router(`/main`,{
                    state:{
                      reload:new Date().getTime()
                    }
                  })
            } else {
                message.error(res.message);
            }
        }) 
    }
    
    useImperativeHandle(ref, () => ({
        open: () => showModal(),
    }))

    // useEffect(()=> {
    //     fetchData(name); 
    // },[page])
    
    return(
        <Modal title="请选择要登入的商户" open={isModalOpen} footer={false} onCancel={handleCancel}>
            <Input placeholder='商户名称' style={{ marginBottom:'10px' }} value={name} onChange={(e)=>{
                setName(e.target.value);
                handleSearch(e.target.value);
            }} />
            <div style={{height:'50vh',overflow:'auto'}}>
                <List
                    itemLayout="horizontal"
                    dataSource={data}
                    loading={flag}
                    locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
                    renderItem={(item:{merchantId:number,merchantName:string}, index) => (
                    <List.Item style={{ borderBottom: '1px solid #eeeeee',cursor:'pointer' }} onClick={()=>{
                        merchantId != item.merchantId && selectMerchant(item.merchantId,item.merchantName)
                    }} >
                        <List.Item.Meta
                        title={<a style={{ color:merchantId == item.merchantId ? '#1677ff' : '#000000e0' }}>{item.merchantName}</a>}
                        description={merchantId == item.merchantId ? '当前登入商户' : ''}
                        />
                    </List.Item>
                    )}
                />
            </div>
            
            <Pagination align="center" showSizeChanger={false} defaultCurrent={page} current={page} pageSize={pageSize} total={total} onChange={(e)=>{ setPage(e);fetchData(name,e); }} />
        </Modal>
    )
}

export default forwardRef(MerchantList)